// extracted by mini-css-extract-plugin
export default {"sdkContainer":"VqnmTcHikN6Dnzpu2aqc","hidden":"jpsrSxTl4mgr4guYQwV6"};